var path = '/app/components/legacy-iframe-support.component.html';
var html = "<iframe style=\"display:none\" id=\"autoalertiframe\" class=\"hidden-iframe iframe-autoalert new-page\" ng-src=\"{{$ctrl.iframeSource}}\"></iframe>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;